import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSubTitle } from "../stores/AppReducer";
import { loginUser } from "../services/apiService";
import type { AppDispatch } from "../stores/AppStore";

function Status() {
    const dispatch = useDispatch<AppDispatch>();
    const tokenParam = useParams();
    const navigate = useNavigate();
    let token;
    const times = useRef(0);
    useEffect(() => {
        if (times.current++ === 0) {
            dispatch(setSubTitle("Status"));
            if (tokenParam) {
                token = (tokenParam as {token: string}).token.replace(/:/, "");
                dispatch(loginUser({token})).then((res: any) => {
                    if (res.type === "put/login/fulfilled") {
                        navigate("/status/:info" )
                    }
                });
            }
        }
    }, []);
    return (
        <div className="home">
            Willkommen 
        </div>
    );
}
export default(Status);
